import React from 'react';

import type { TFaceCardSizePoint3 } from './base-face-card/BaseFaceCard.point3';
import type { LargeFaceCardPoint3Props } from './large-face-card/LargeFaceCard.point3';
import { LargeFaceCardPoint3 } from './large-face-card/LargeFaceCard.point3';
import type { SmallFaceCardPoint3Props } from './small-face-card/SmallFaceCard.point3';
import { SmallFaceCardPoint3 } from './small-face-card/SmallFaceCard.point3';

export type FaceCardPoint3Props = { size?: TFaceCardSizePoint3 } & (
  { size: 'large' } & LargeFaceCardPoint3Props
| { size: 'small' } & SmallFaceCardPoint3Props
);

export function FaceCardPoint3({
  size = 'large',
  ...props
}: FaceCardPoint3Props): React.JSX.Element {
  return (
    <React.Fragment>
      {size === 'large' && <LargeFaceCardPoint3 {...props} />}
      {size === 'small' && <SmallFaceCardPoint3 {...props} />}
    </React.Fragment>
  );
}
